import { useCallback } from 'react';

import { personalHealthApi, useGetFederatedUserProfileQuery } from '@shared/services/personalHealth';
import { FEDERATED_PROFILES_TAGS } from '@shared/services/personalHealth/endpoints/getFederatedUserProfile';
import { useAppDispatch } from '@shared/stores/rootTypes';

import useIsAuthenticated from '../useIsAuthenticated';
import { useSettledQueryState } from '../useSettledQueryState';

interface UseCurrentFederatedUserParams {
  skip?: boolean;
}

const useCurrentFederatedUser = ({ skip = false }: UseCurrentFederatedUserParams) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useIsAuthenticated();

  const federatedUserProfileQuery = useGetFederatedUserProfileQuery(
    // Ignore this parameter as the `Secure` parameter is always set to `true` for federated user profile
    { Secure: true },
    {
      skip: !isAuthenticated || skip,
    }
  );
  const { data: federatedUserProfile, error } = federatedUserProfileQuery;
  const { isFetching, isLoading, retry } = useSettledQueryState(federatedUserProfileQuery);

  const clearFederatedUserProfile = useCallback(() => {
    dispatch(personalHealthApi.util.invalidateTags([FEDERATED_PROFILES_TAGS]));
  }, [dispatch]);

  return {
    clearFederatedUserProfile,
    hasNoPhoneNumber: !federatedUserProfile?.Profile?.ContactNumber,
    isFetching,
    isLoading,
    refetchUser: retry,
    userProfile: federatedUserProfile?.Profile,
    userProfileError: error,
  };
};

export { useCurrentFederatedUser };
